import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { ButtonReset } from '@helpers/global';
import { Device, until } from '@helpers/media';
import styled from 'styled-components';
import { CommonTextInputStyles } from '../Textbox/Textbox.styles';
const Input = styled.input `
  ${CommonTextInputStyles};

  max-width: 79px;
  text-align: center;
`;
const InputWrapper = styled.div `
  --buttonSize: 28px;

  display: flex;
  gap: 13px;
  align-items: center;
`;
const Button = styled.button `
  ${ButtonReset};
  ${transition('background-color, border-color')};

  display: grid;
  place-items: center;
  height: var(--buttonSize);
  width: var(--buttonSize);
  border-radius: 5000px;
  border: 1px solid ${brand.green.dark};
  color: ${brand.global.white};
  background-color: ${brand.green.default};
  flex: 0 0 var(--buttonSize);

  svg {
    width: 18px;
  }

  /* Mobile click styles - button should mimic press */
  @media ${until(Device.TabletLarge)} {
    ${transition('background-color, border-color, transform', 0.15)};

    &:active {
      transform: translateY(1.5px);
    }
  }

  &:focus-visible {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
    outline-color: ${brand.green.dark};
  }

  &:focus-visible,
  &:hover {
    background-color: ${brand.green.dark};
  }

  &:disabled {
    background-color: ${brand.grey.light};
    border-color: ${brand.grey.dark};
    color: ${brand.grey.dark};
    cursor: not-allowed;
  }
`;
const NumberStyles = {
    Input,
    InputWrapper,
    Button,
};
export default NumberStyles;
